if (!customElements.get('ck-deferred-section')) {
  class CkDeferredSection extends HTMLElement {
    connectedCallback() {
      this.deferredTemplate = this.querySelector(':scope > template');
      if (!this.deferredTemplate && !this.dataset.sectionId) return;

      if (!('IntersectionObserver' in window)) {
        this.render();
        return;
      }

      this.observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) this.render();
      }, { rootMargin: '100% 0px' });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.abortController?.abort();
    }

    render() {
      this.observer?.disconnect();

      if (this.deferredTemplate?.isConnected) {
        this.deferredTemplate.replaceWith(this.deferredTemplate.content.cloneNode(true));
        this.classList.add('is-rendered');
        return;
      }

      if (this.rendering || !this.dataset.sectionId) return;
      this.rendering = true;
      this.abortController = new AbortController();

      const url = `${window.location.pathname}?section_id=${encodeURIComponent(this.dataset.sectionId)}`;

      fetch(url, { signal: this.abortController.signal })
        .then((response) => (response.ok ? response.text() : Promise.reject(response.status)))
        .then((text) => {
          const source = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('ck-deferred-section');

          if (!source || !this.isConnected) return;

          this.innerHTML = source.innerHTML;
          this.classList.add('is-rendered');
          this.dispatchEvent(new CustomEvent('ck-deferred-section:rendered', { bubbles: true }));
        })
        .catch(() => {
          this.rendering = false;
        });
    }
  }

  customElements.define('ck-deferred-section', CkDeferredSection);
}
